<template>
  <div
    class="v-radio-input__wrapper"
    :class="{ [extraClass]: !!extraClass, ['checked']: !!checked }"
    @click="clickHandler"
  >
    <VHint
      v-if="hintText"
      :text="hintText"
      position="down"
      extraClass="radio-input-hint"
    ></VHint>
    <div class="item-value"></div>
    <input :checked="checked" type="radio" :name="name" />
    <label>{{ label }}</label>
    <div class="check"><div class="inside"></div></div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

import VHint from "@/components/VHint";

export default Vue.component("VRadioInput", {
  props: {
    name: VueTypes.string,
    label: VueTypes.string,
    value: VueTypes.any,
    checked: VueTypes.bool.def(false),
    hintText: VueTypes.string,
    extraClass: VueTypes.string
  },

  components: {
    VHint
  },

  methods: {
    clickHandler(e) {
      this.$emit("input", { label: this.name, value: this.value }, e);
    }
  }
});
</script>

<style lang="scss" scoped>
$ns: "v-radio-input";

.#{$ns} {
  &__wrapper {
    z-index: 0;
    color: #b4b2b2;
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    justify-content: flex-end;
    position: relative;
    width: 100%;
    cursor: pointer;

    input[type="radio"] {
      position: absolute;
      visibility: hidden;

      &:checked ~ {
        label {
          color: #1f1f1f;
          font-family: Lato-Regular, Arial, sans-serif;
        }

        .check {
          border: 1px solid $primary-color;

          &::before {
            background: $primary-color;
          }
        }
      }
    }

    label {
      cursor: pointer;
      display: block;
      position: relative;
      font-weight: 300;
      font-size: 14px;
      line-height: 1.5;
      margin: 0 0 0 10px;
      transition: all 0.25s linear;
      font-family: "Lato-Light", Arial, sans-serif;
    }

    .check {
      position: relative;
      border: 1px solid #b4b2b2;
      border-radius: 100%;
      height: 20px;
      width: 20px;
      min-width: 20px;
      z-index: 5;
      transition: border 0.25s linear;

      &::before {
        display: block;
        position: absolute;
        content: "";
        border-radius: 100%;
        height: 10px;
        width: 10px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        margin: auto;
        transition: background 0.25s linear;
      }
    }

    .item-value {
      &:hover {
        .check {
          border: 1px solid $primary-color;
        }

        label {
          color: #1f1f1f;
        }
      }
    }
  }
}

// css for Hint
/deep/ .radio-input-hint {
  margin-left: 15px;

  span::after {
    color: $secondary-text-color;
    font-family: Lato-Regular, Arial, sans-serif;
    font-size: 14px;
    line-height: 161%;
    display: inline-block;
    text-align: left;
    width: 270px;
    padding: 20px 15px;
    margin-bottom: 20px;
  }
}
</style>
